export default function initLoadingForms() {
    setTimeout(function (event) {
        document.querySelectorAll('.dccs-form-wrapper').forEach($form => {
            const $formContainer = $form.parentNode;
            const $loadingInfo = $formContainer.querySelector('.form-is-loading');

            const otherForm = !$formContainer.classList.contains('support');
            if ($form.classList.contains('is-hidden') && otherForm) {
                $form.classList.remove('is-hidden');
                $loadingInfo.remove();
                if ($form.dataset.scrollTo) {
                    const $scrollToContainers = $form.querySelectorAll('div.' + $form.dataset.scrollTo);
                    let $scrollToContainer = null;

                    if ($scrollToContainers.length > 0) {
                        $scrollToContainer = $scrollToContainers[0];

                        window.scrollTo({
                            top: window.pageYOffset + $scrollToContainer.getBoundingClientRect().top - 16,
                            behavior: 'smooth',
                        });
                    }
                }
            }
        });
    }, 1500);
}
